import { IMaintenanceModel } from 'app/shared/model/maintenance-model.model';
import { ICompany } from 'app/shared/model/company.model';
import { IPart } from 'app/shared/model/part.model';

export interface IMaintenanceReview {
  id?: number;
  reviewOrder?: number | null;
  km?: number | null;
  period?: number | null;
  hour?: number | null;
  description?: string | null;
  maintenanceModel?: IMaintenanceModel | null;
  company?: ICompany | null;
  parts?: IPart[] | null;
}

export const defaultValue: Readonly<IMaintenanceReview> = {};
